import axios from '@/axios'
import plainAxios from 'axios'
import EventBus from '@/eventbus'

export default {
  uploadToS3(presigned, file) {
    return new Promise((resolve, reject) => {
      plainAxios
        .put(presigned.url, file, {
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            EventBus.$emit(file.name, percentCompleted)
          }
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  uploadFromUrl(url, filename) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/storage/upload-from-url`, {
          url: url,
          filename: filename
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  uploadVideo(url, filename, size, type) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/storage/upload-video`, {
          url: url,
          filename: filename,
          size: size,
          type: type
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getPresignedLink(file) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/storage/presigned-link`, file)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
